module.exports = Object.freeze([
	{ label: 'Successful', key: 'successful', order: 0 },
	{ label: 'Unsuccessful', key: 'unsuccessful', order: 1 },
	{ label: 'Interview Pending', key: 'pending', order: 2 },
	{ label: 'Not Interviewed', key: 'notInterviewed', order: 3 },
]);


//////////////////
// WEBPACK FOOTER
// ../server/constants/statuses/matched-candidate-statuses.js
// module id = 1406
// module chunks = 0